<template>
	<div class="container p-0 mt-3">
		<div class="card">
			<div v-if="creatorUser" class="card-header">
				<h3 v-if="!isWalking">{{ creatorUser.name }} te ha compartido la carta</h3>
				<h3 v-else>Accede a nuestra carta</h3>
			</div>
			<div class="row g-0 justify-content-center">
				<div class="col-md-8">
					<div class="card-body h-100 align-content-center">
						<div v-if="isValidReservation">
							<p class="text-center">¿Cómo quieres que te llamemos?</p>
							<div v-if="isValidReservation" class="input-group mb-3">
								<span class="input-group-text"><i class="fas fa-user"></i></span>
								<input v-model="signupName" class="form-control" placeholder="Introduce tu nombre (sin apellidos):" type="text" @focus="deselectCheckboxes">
							</div>
						</div>

						<div v-if="invitedUsers.length" class="mb-3">
							<div v-if="isValidReservation" class="text-start">
								¿Estás en la lista? Selecciona tu nombre.
							</div>

							<div v-if="!isWalking" class="col-md-6 col-lg-auto text-start">
								<div v-if="creatorUser" :key="creatorUser.uid" class="form-check">
									<input v-if="isValidReservation" :id="creatorUser.uid" v-model="selectedInvitedUser" :value="creatorUser.uid" class="form-check-input" disabled type="radio">
									<label :for="creatorUser.uid" class="form-check-label">
										{{ creatorUser.name }}
									</label>
								</div>
							</div>

							<div v-for="invitedUser in invitedUsers" :key="invitedUser.uid" class="col-md-6 col-lg-auto text-start">
								<div class="form-check">
									<input v-if="isValidReservation" :id="invitedUser.uid" v-model="selectedInvitedUser" :disabled="invitedUser.typeHost === 1" :value="invitedUser.uid" class="form-check-input" type="radio">
									<label :for="invitedUser.uid" class="form-check-label">
										{{ invitedUser.name }}
									</label>
								</div>
							</div>
						</div>

						<div v-if="isValidReservation" class="row-center">
							<button :disabled="(!signupName && (selectedInvitedUser === 1 || !selectedInvitedUser))" class="btn btn-primary w-100" type="button" @click="submitAcceptInvitationMenu()">
								{{ acceptButtonText }}
							</button>
						</div>

						<div v-if="showErrorMessageEmail" id="reservationResponseCollapse" class="col-12">
							<div class="alert alert-danger" role="alert">
								¿Cómo podemos llamarte?
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div id="showAlertRedirectMenuAndroid" aria-hidden="true" class="modal fade" tabindex="-1">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content border-secondary border-1">
				<div class="modal-body text-center">
					<p class="fs-3">Estamos preparando tu carta personalizada, un momento…</p>
					<SpinnerIcon class="fw-bold fs-3"/>
					<p class="fs-5">Si no redirige automáticamente pulsa en "Ver Menú",</p>
					<div class="d-grid col-6 mx-auto">
						<button class="btn btn-primary mb-2" @click="redirectAddGuestResult">Ver Menú</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div id="showAlertRedirectMenuIOS" aria-hidden="true" class="modal fade" tabindex="-1">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content border-secondary border-1">
				<div class="modal-body text-center">
					<p class="fs-3">Tu carta personalizada está casi lista.</p>
					<p class="fs-6">Haz clic en el botón para acceder a tu carta.</p>
					<div class="d-grid col-6 mx-auto">
						<button class="btn btn-primary mb-2" @click="redirectAddGuestResult">Ver Carta</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {dateFormatterService} from "@/service/dateFormatterService";
import {hideAllModals, showModal} from "@/utils";
import SpinnerIcon from "@/components/core/icons/SpinnerIcon";

export default {
	name: "InvitationMenu",
	components: {SpinnerIcon},
	inject: {
		userRepository: 'userRepository',
		manageToken: 'manageToken',
		reservationRepository: 'reservationRepository',
	},
	data() {
		return {
			selectedInvitedUser: null,
			signupName: null,
			showErrorMessageEmail: false,
			hostCode: '',

			textStandard: 'Confirmar',
			textLoading: 'Confirmando...',
			isLoadingBtn: false,

			isIOS: false,

			addGuestResult: {
				reservationId: null,
				userId: null,
				link: null,
			}
		}
	},
	computed: {
		...mapState('user', ['user']),
		...mapGetters('invitation', ['creatorUser', 'reservationInfo', 'isWalking', 'invitedUsers', 'isValidReservation']),

		acceptButtonText() {
			return this.isLoadingBtn ? this.textLoading : this.textStandard;
		}
	},
	watch: {
		selectedInvitedUser(newVal) {
			if (newVal && this.signupName) {
				this.signupName = '';
			}
		}
	},
	beforeUnmount() {
		this.date = dateFormatterService.formattedDate(this.reservationInfo.startDateTime);
		this.time = dateFormatterService.formattedTime(this.reservationInfo.startDateTime);

		console.log({reservationINfo: this.reservationInfo})
		console.log({user: this.user})
	},
	mounted() {
		this.isIOS = /iP(hone|od|ad)/.test(navigator.userAgent);
		this.checkUserAndRedirect();
	},
	beforeMount() {
		console.log('beforeMount', this.isIOS)

	},
	methods: {
		async checkUserAndRedirect() {
			console.log('tiene usuario ?',)
			if (this.user) {
				const isMemberOfReservation = this.reservationInfo.reservationUsers.find(user => user.userId === this.user.id);

				if (isMemberOfReservation) {
					await this.reservationRepository.enableReservation({reservationWid: this.reservationInfo.id});

					if (this.isIOS) {
						showModal('showAlertRedirectMenuIOS');
						window.location.href = `https://${this.reservationInfo.venueParams.subdomain}.wewelcom.io/menu?r=${this.reservationInfo.id}&uid=${this.user.hostCode}`;
					} else {
						showModal('showAlertRedirectMenuAndroid');
						window.location.href = `https://${this.reservationInfo.venueParams.subdomain}.wewelcom.io/menu?r=${this.reservationInfo.id}&uid=${this.user.hostCode}`;
					}

				} else {
					await this.reservationRepository.addInvitedUser(this.reservationInfo.id, this.user.id, 1);
					/*setTimeout(() => {
						window.location.href = `https://${this.reservationInfo.venueParams.subdomain}.wewelcom.io/menu?r=${this.reservationInfo.id}&uid=${this.user.hostCode}`;
					}, 2000);*/

					if (this.isIOS) {
						showModal('showAlertRedirectMenuIOS');
						window.location.href = `https://${this.reservationInfo.venueParams.subdomain}.wewelcom.io/menu?r=${this.reservationInfo.id}&uid=${this.user.hostCode}`;
					} else {
						showModal('showAlertRedirectMenuAndroid');
						window.location.href = `https://${this.reservationInfo.venueParams.subdomain}.wewelcom.io/menu?r=${this.reservationInfo.id}&uid=${this.user.hostCode}`;

						
					}
				}
				// this.redirectToMenu(this.reservationInfo.id, this.user.hostCode);
			} else {
				console.log('no hay usuario')
			}
		},
		async submitAcceptInvitationMenu() {
			this.isLoadingBtn = true;

			if (this.selectedInvitedUser === 1 || !this.selectedInvitedUser) {
				//TODO: Si agrega el nombre
				this.isLoadingBtn = true;

				if (!this.signupName) {
					alert('El nombre debe tener un valor');
					this.isLoadingBtn = false;
					return;
				}

				const data = {
					invitedUserName: this.signupName,
					hostCode: this.selectedInvitedUser,
					reservationWid: this.reservationInfo.id
				};
				const response = await this.userRepository.createGuestUserMenu(data);
				if (response.result === 0) {

					this.isLoadingBtn = false;

					const invitedUser = response.invitedUser;
					invitedUser.creationDate = new Date();
					this.manageToken.setToken(response.token);
					console.log("vamosss", this.reservationInfo, this.reservationInfo.id, invitedUser.uid)

					this.addGuestResult = {
						reservationId: this.reservationInfo.id,
						userId: invitedUser.uid,
						link: response.menuLink
					}
					console.log('esto es addGuestResult', this.addGuestResult)
					this.redirectToMenu(this.reservationInfo.id, invitedUser.hostCode);

				} else {
					hideAllModals();
				}
				this.isLoadingBtn = false;

			} else {
				//TODO: selecciona el checkbox
				this.isLoadingBtn = false;
				console.log('pasa por else');

				this.redirectToMenu();
				// window.location.href = `https://${this.reservationInfo.venueParams.subdomain}.wewelcom.io/menu?r=${this.reservationInfo.id}&uid=${this.selectedInvitedUser}`;
			}
		},
		redirectToMenu() {
			const reservationId = this.addGuestResult.reservationId || this.reservationInfo.id;
			const userHostCode = this.addGuestResult.userId || this.selectedInvitedUser;

			if (this.isIOS) {
				showModal('showAlertRedirectMenuIOS');
				this.redirectToMenuInsta(reservationId, userHostCode);
			} else {
				showModal('showAlertRedirectMenuAndroid');
				this.redirectToMenuInsta(reservationId, userHostCode);
			}
		},

		redirectToMenuInsta(reservationId, userHostCode) {
			console.log('que es reservatiodId', reservationId)
			console.log('que es reservatiodId', userHostCode)
			window.location.href = `https://${this.reservationInfo.venueParams.subdomain}.wewelcom.io/menu?r=${reservationId}&uid=${userHostCode}`;
		},

		redirectAddGuestResult() {

			console.log('usuario guardado', this.addGuestResult)
			console.log(`${this.addGuestResult.link}&uid=${this.addGuestResult.userId}`)
			window.location.href = `https://${this.reservationInfo.venueParams.subdomain}.wewelcom.io/menu?r=${this.addGuestResult.reservationId}&uid=${this.addGuestResult.userId}`;
		},

		deselectCheckboxes() {
			this.selectedInvitedUser = null;
		}
	}
}
</script>
